// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationWebpageSupportDocumentApi,
  ICertificationWebpageSupportDocumentApiRequest,
  ICertificationWebpageSupportDocumentApiListResponse,
  ICertificationWebpageSupportDocumentApiGetListAttrs,
  ICertificationWebpageSupportDocumentApiDownloadDocumentAttrs,
  ICertificationWebpageSupportDocumentApiDownloadDocumentResponse,
} from 'interfaces/webpage/certification/registration/precondition'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class CertificationWebpageSupportDocumentApi
  extends BaseApi<ICertificationWebpageSupportDocumentApi>
  implements ICertificationWebpageSupportDocumentApiRequest
{
  readonly url = ApiConstantHc.CERTIFICATION_REGISTRATION_PRECONDITION_SUPPORT_DOCUMENT_URL
  private certificationRegistrationSupportDocumentUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get support document list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpageSupportDocumentApiGetListAttrs} payload
   *
   * @return {Promise<ICertificationWebpageSupportDocumentApiListResponse>} Promise<ICertificationWebpageSupportDocumentApiListResponse>
   */
  async certificationWebpageSupportDocument_getList(
    payload: ICertificationWebpageSupportDocumentApiGetListAttrs,
  ): Promise<ICertificationWebpageSupportDocumentApiListResponse> {
    return this.POST(
      `${this.certificationRegistrationSupportDocumentUrl}/list/${payload.params.assessmentId}`,
      {},
      { ...payload.requestConfig },
    )
  }

  /**
   * @description Download assessment general proof document
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpageSupportDocumentApiDownloadDocumentAttrs} payload
   *
   * @return {Promise<ICertificationWebpageSupportDocumentApiDownloadDocumentResponse>} Promise<ICertificationWebpageSupportDocumentApiDownloadDocumentResponse>
   */
  async certificationWebpageSupportDocument_downloadDocument(
    payload: ICertificationWebpageSupportDocumentApiDownloadDocumentAttrs,
  ): Promise<ICertificationWebpageSupportDocumentApiDownloadDocumentResponse> {
    return this.POST(
      `${this.certificationRegistrationSupportDocumentUrl}/download/${payload.params.blobId}`,
      {},
      { ...payload.requestConfig, responseType: 'blob' },
    )
  }
}
